export default __webpack_public_path__ + "static/phone1-07e69aa1917ba593a50386023ad84dd6.png";